import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

const rootEl = document.getElementById('app-site');
const MainApp = require('./MainApp').default;
let render = () => {
  ReactDOM.render(
    <MainApp/>,
    rootEl
  );
};

if (module.hot) {
  module.hot.accept('./MainApp', () => render());
}

render();